module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo4-2fc33808c0c7d750fa4fcf1b1abd40bd.png";